import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import moment from "moment";
import { withTranslation } from "react-i18next";
import { sendAnalytics } from "../../../action/homeAction";
import { popupOpenClose, setRegPage } from "../../../action/action";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { setGoHome, setLoginRequired } from "../../action/homeAction";
import { CLICKED, CMSPath, EXIT, GOOGLE_CAPTCHA_KEY } from "../../../config/constant";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import SuccessFailScreen from "../../UI/SuccessFailScreen";
import { formatLocalTime, formatTime, toBool } from "../../JS/utility";
import { dateFormatHandler } from "../../../JS/dateFormatHandler";
import MiniLoader from "../../UI/MiniLoader";
import { scrollToTop } from "../../../JS/scrollToTop";
import Gha_WelcomePage from "./Gha_WelcomePage"
import { enrollGhaUser, fetchAvailableLanguages } from "../../../action/gha";
import Loader from "../../UI/loader";
import ShowWeakPasswordPopup from "./ShowWeakPasswordPopup";
import $ from "jquery";
import { inAppBrowser } from "../../JS/inAppBrowser";

let emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const isStrongPassword = (password) => {
    // Regular expressions for different criteria
    const minLength = /^.{8,}$/;                       // At least 8 characters
    const onlyAlphabet = /^[A-Za-z\d!@#$%^&*(),.?":{}|<>]+$/; // Only English alphabet characters, numbers, and symbols
    const hasUppercase = /[A-Z]/;                     // At least one uppercase letter
    const hasLetter = /[A-Za-z]/;                      // At least one letter
    const hasNumber = /\d/;                            // At least one number
    const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/;        // At least one symbol
    const noSpaces = /^\S*$/;                          // No spaces anywhere

    // Check if all criteria are met
    return minLength.test(password) &&
        onlyAlphabet.test(password) &&
        hasUppercase.test(password) &&
        hasLetter.test(password) &&
        hasNumber.test(password) &&
        hasSymbol.test(password) &&
        noSpaces.test(password);
}

 
const Gha_NewJoin = (props) => {
    // const [availableLanguages,setAvailableLanguages]=useState([])
    // const [fetchingLang, setFetchinglang]=useState(false);
    // const [isLangFetchingFailed, setIsLangFetchingFailed]=useState(false);
    const [signUpFormData, setSignUpFormData] = useState({ marketing :false, hotelMarketing:false});
    const [showLoader, setShowLoader]=useState(false);
    const [isTCselected, setIsTCselected]=useState(false)
    // const [requiredLinks,setRequiredLinks]=useState({tncLink:"",ppLink:""})
    const [showNotStrongPasswordPopup, setShowNotStrongPasswordPopup]=useState(false);
    const [isCaptchaPassed, setIsCaptchaPassed]=useState(false);
    const [isIframeLoading, setIsIframeLoading]=useState(true);
 
    const SITE_KEY_CAPTCHA=GOOGLE_CAPTCHA_KEY;

    let widgetSesstionId = localStorage.getItem("ghaSessionToken");
    let label = getDefaultAnalyticsLabel({
        appVersion: props.installedAppVersion
            ? `${props.installedAppVersion}(${props.installedAppBuildNo})`
            : "",
    });

    const sendAnalytic = (isSuccess,task,res) => {
        props.sendAnalytics(
            props.guestDetail,
            props.currentWidgets.widgetType,
            `${task} response ${isSuccess ? 'Success' : "failed"}`,
            {
                ...label,
                layoutTab: props.currentHomePage.tabName,
                element: "widget",
                widgetSessionId: widgetSesstionId,
                errorStatus: JSON.stringify(res),
                errorMessage: JSON.stringify(
                    res 
                ),
            },
            0,
            props.guestIsLoggedIn
        );
    }

 
    const { t } = props;

    // const getAvailableLanguages=()=>{
    //     setFetchinglang(true);
        
    //     fetchAvailableLanguages()
    //     .then(res=>{
    //         if(res.status==200 && res.data.payload && res.data.payload.data && res.data.payload.tncLink && res.data.payload.ppLink ){
    //             setAvailableLanguages(res.data.payload.data);
    //             setRequiredLinks({
    //                 tncLink:res.data.payload.tncLink,
    //                 ppLink:res.data.payload.ppLink
    //             })
                
    //             sendAnalytic(true,"GET available languages")
    //         }
    //         else{
    //              throw new Error();
    //             // props.closeOrderPopUp(true, t('gha.errors.getAvailableLanguages'), "", true)
    //             // sendAnalytic(false, "GET available languages", res)
    //         }
    //     })
    //     .catch((err)=>{
             
    //         setIsLangFetchingFailed(true);
    //         props.closeOrderPopUp(true, t('gha.errors.getAvailableLanguages'), "", true)
    //         sendAnalytic(false, "GET available languages", err)

    //     })
    //     .finally(()=>{
    //         setFetchinglang(false);
    //     })
    // }

    const registerUser=(formData)=>{
        setShowLoader(true);
        enrollGhaUser(formData)
        .then((res)=>{
            if(res.status==200 && res.data && res.data.payload){
                console.log(res.data.payload)
                props.closeOrderPopUp(true, t('gha.success.enroll_user'), "", false)
                props.handleNext(true, res.data.payload)
            }else{
                props.closeOrderPopUp(true, t('gha.errors.enroll_user'), "", true)
                sendAnalytic(false, "LOGIN USER", res)
            }

        })
        .catch((err)=>{
            console.log(err)
            sendAnalytic(false, "LOGIN USER",err)
            props.closeOrderPopUp(true, err || t('gha.errors.something_went_wrong'), "", true)

        })
        .finally(()=>{
            setShowLoader(false);
        })
        
    }

    const handleSubmit=()=>{
        console.log("object sign up is", signUpFormData)
        for (const field of ["languageCode", "firstName", "lastName",  "username", "password"]){
            if(!signUpFormData.hasOwnProperty(field) || signUpFormData[field]==''){
                props.popupOpenClose("true", `${t("gha.please_enter_your")} ${field == "username" ? "email" : (field == "languageCode" ?"language" :field)}`);
                return;
            }
        }

        if(signUpFormData.password!=signUpFormData.confirmPassword){
            props.popupOpenClose("true", `${t("gha.Confirm_password_not_match")}`);
            return;
        }

        if (!emailRegex.test(signUpFormData.username)) {
            props.popupOpenClose(true, "Please enter a valid email");
            return;
        }

        if (!isStrongPassword(signUpFormData.password)){
            setShowNotStrongPasswordPopup(true);
            // props.popupOpenClose("true", `${t("gha.password_not_strong")}`);
            return;
        }

        if(!isTCselected){
            props.popupOpenClose("true", `${t("gha.select_TC")}`);
            return;
        }
        
        if(!isCaptchaPassed){
            props.popupOpenClose("true", `${t("gha.verify_captcha")}`);
            return;
        }

        console.log("signUpFormData", signUpFormData)
        const formData= JSON.parse(JSON.stringify(signUpFormData));
        delete formData["confirmPassword"];
        console.log("signUpFormData", signUpFormData)
        registerUser(formData);
        

    }

    const handleChangeValue=(data)=>{
        // console.log(JSON.stringify(data),"change value")
        const formData = JSON.parse(JSON.stringify(signUpFormData));
        setSignUpFormData({...formData,...data});
    }
 
    const openLinkHandler = (link, displayName) => {

        if (link) {
            inAppBrowser(link,{...props,menuColor:{assetFontColor:"#000000",backgroundColor:"#D0D2D7"}}, false, {displayName: displayName, dontSetCurrentWidget: true, targetUrl:link})
        }

    }

    
    
    useEffect(() => {
        
        scrollToTop();
        // setFetchinglang(false);
        setIsCaptchaPassed(false);
        // setIsLangFetchingFailed(false);
        // getAvailableLanguages();
        
       
        const captchaVerification=(e)=>{
            console.log("captcha status msg received")
            
            try {
                if(e && e.data){
                    const response= JSON.parse(e.data);
                    console.log(response)
                    setIsCaptchaPassed(response.status)   
                }   
            } catch (error) {
             console.log(error)   
            }
        }

        window.addEventListener("message",captchaVerification);

    
        return ()=>{
            window.removeEventListener("message",captchaVerification);
        }
        
        }, []);

     
        
 
    
    useEffect(() => { console.log("availableLanguages", props.availableLanguages)}, [props.availableLanguages])
    useEffect(() => { console.log("isCaptchaPassed", isCaptchaPassed)}, [isCaptchaPassed])


    return (
        <>
        {

            props.fetchingLang
            ?
                    <>
                        <div></div>
                        <Loader displayMsg={"Fetching Languages.."} showClose={true} close={() => props.setGoHome(true)} />
                    </> 
            :
            <>

                {
                    props.isLangFetchingFailed
                    ?
                                <SuccessFailScreen
                                    status={false}
                                    showTryAgain={false}
                                    showClose={true}
                                    statusMessage1={"Something Went Wrong"}
                                    statusMessage2={
                                         "Failed to fetch languages."
                                    }
                                    close={props.setGoHome}
                                 />
                    :
                    <>
                                    <header class="inner-pages w-footer subpages">
                                        <a class="button-back" onClick={props.handleGoBack}></a>
                                        <div class="heading align-center">
                                            <div class="splash-brand">
                                                <img src={`${CMSPath}${props.logo}`} />
                                            </div>
                                        </div>
                                    </header>
                                    <section class="widgets">
                                        <div class="widget-header">
                                            <div class="widget-header-img">
                                                <img src={require("./assests/join.png")}
                                                />
                                            </div>
                                            <div class="widget-header-title"><strong>JOIN</strong> VICEROY DISCOVERY LOYALTY</div>
                                        </div>
                                        <div id="GHALogin" class="widgets sign-up">
                                            <div class="row sign-up-form new-join">
                                                <h4>{t("gha.account_information")}</h4>
                                                <div class="form-row">
                                                    <label>{t("gha.language_preferance")}<span style={{ color: 'red' }}>*</span></label>
                                                    {

                                                        <select defaultValue={""} onChange={e => {
                                                            console.log(e.target.value);
                                                            handleChangeValue({ languageCode: e.target.value })
                                                        }}>
                                                            <option key={"select_a_language"}  disabled={true} value={""}>{t("gha.select_a_language")}</option>
                                                            {props.availableLanguages && props.availableLanguages.map(lan => {
                                                                return <option  key={lan.id} value={lan.id}>
                                                                    {lan.name}
                                                                </option>
                                                            })}
                                                        </select>


                                                    }
                                                </div>


                                                <div class="form-row">
                                                    <label>{t("gha.first_name")}<span style={{ color: 'red' }}>*</span></label>
                                                    <input type="text" placeholder="Enter your first name" value={signUpFormData.firstName || ''} onChange={(e) => handleChangeValue({ firstName: e.target.value })} />
                                                </div>
                                                <div class="form-row">
                                                    <label>{t("gha.last_name")}<span style={{ color: 'red' }}>*</span></label>
                                                    <input type="text" placeholder="Enter your last name" value={signUpFormData.lastName || ''} onChange={(e) => handleChangeValue({ lastName: e.target.value })} />
                                                </div>
                                                <div class="form-row">
                                                    <label>{t("gha.email_address")}<span style={{ color: 'red' }}>*</span></label>
                                                    <input type="text" placeholder="Enter your email address" autoComplete='email' value={signUpFormData.username || ''} onChange={(e) => handleChangeValue({ username: e.target.value })} />
                                                </div>
                                                <div class="form-row">
                                                    <label>{t("gha.password")}<span style={{ color: 'red' }}>*</span></label>
                                                    <input type="password" placeholder="Enter your password" value={signUpFormData.password || ''} onChange={(e) => handleChangeValue({ password: e.target.value })} />
                                                </div>
                                                <div class="form-row">
                                                    <label>{t("gha.confirm_password")}<span style={{ color: 'red' }}>*</span></label>
                                                    <input type="password" placeholder="Retype your password" value={signUpFormData.confirmPassword || ''} onChange={(e) => handleChangeValue({ confirmPassword: e.target.value })} />
                                                </div>
                                                <h4>
                                                    {t("gha.marketing_com")}

                                                </h4>
                                                <div class="form-row checkbox">
                                                    <input type="checkbox" name="GHA Email Promos" checked={signUpFormData.hasOwnProperty("marketing") && signUpFormData["marketing"]} onChange={(e) => { handleChangeValue({ marketing: e.target.checked }) }} />
                                                    <label>
                                                        {t("gha.market_dis1")}
                                                        <span class="disclaimer">
                                                            {t("gha.market_dis2")}
                                                        </span></label>

                                                </div>
                                               <div class="form-row checkbox">
                                                <input type="checkbox" name="Viceroy Email Promos"  checked={signUpFormData.hasOwnProperty("hotelMarketing") && signUpFormData["hotelMarketing"]} onChange={(e) => { handleChangeValue({ hotelMarketing: e.target.checked }) }}  />
                                                    <label>
                                                    {t("gha.hotel_market_dis1")}
                                                        
                                                        <span class="disclaimer" >
                                                        {t("gha.hotel_market_dis2")}
                                                           </span>
                                                        </label>
                                          </div>  

                                                <h4>{t("gha.tnc")}</h4>
                            <div class="form-row checkbox">
                                <input type="checkbox" name="Accept terms" checked={isTCselected} onChange={(e)=>{setIsTCselected(e.target.checked)}}/>
                                    <label>BY ENROLING AS A VICEROY DISCOVERY MEMBER, I AGREE TO THE <span onClick={()=>openLinkHandler( props.requiredLinks.tncLink , "TERMS & CONDITIONS")}>TERMS & CONDITIONS</span> INCLUDING THE <span onClick={()=>openLinkHandler( props.requiredLinks.ppLink, "GHA DISCOVERY PRIVACY POLICY")} >GHA DISCOVERY PRIVACY POLICY</span>, CAN STORE AND PROCESS MY DATA FOR THE PURPOSES OF RECOGNISING AND REWARDING STAYS IN HOTELS ACROSS THE GHA DISCOVERY NETWORK.</label>
                                        
                            </div> 

                            <div class="iframe gha">
                            {   isIframeLoading &&
                                <div class="loader-ring"><img src="layout_2/assests/loader.png" /></div>}
                            
            
                                <iframe frameborder="0"  class="iframe-gha"
                                onLoad={()=>{
                                    setIsIframeLoading(false);
                                    $(".Iframe-gha-container").attr("style", "width: 100%; height: 100% !important")

                                }}
                                 style={{ width: 0, height: 0 }}  className='Iframe-gha-container'
                                 src={`https://guest-journey.s3.amazonaws.com/static/captcha.html?site_key=${encodeURIComponent(SITE_KEY_CAPTCHA)}`}>

                                </iframe>
                         
                            </div>
                                                <div class="form-controls">

                                                    {showLoader ? <button disabled class="primary w-100"><div class="loader-ring"><img src="layout_2/assests/loader.png" /></div> {t('gha.joining_you_in')}</button> :
                                                        <button class="primary w-100" onClick={handleSubmit}>Become a Member</button>}

                                                </div>
                                            </div>
                                        </div>
                                    </section>

                                 { showNotStrongPasswordPopup &&  <ShowWeakPasswordPopup message={t("gha.password_not_strong")} onClick={()=>{setShowNotStrongPasswordPopup(false)}}/>}
                    </>
                }
               
                    </>

            }

            
            
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
            : "",
        logo: state.store.home.currentDuration.brandingInfo
            ? state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl
            : "",
    };
};

export default connect(mapStateToProps, { setGoHome,  popupOpenClose,closeOrderPopUp, sendAnalytics })(
    withTranslation("translations")(Gha_NewJoin)
);
